import { Client } from 'types/clients';
import React, { useEffect } from 'react';
import { DialogConfirm } from '../../../components/elements/DialogConfirm';
import { Stack } from '@mui/material';
import { InputText } from '../../../components/elements/InputText';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createClientYuq } from 'utils/validate';
import { FormCreateClient } from '../create/hook';

type EditClientModalProps = {
  open: boolean;
  client?: Client;
  onClose: () => void;
  onSubmit: (value: FormCreateClient) => void;
};

export const EditClientModal = ({ open, client, onClose, onSubmit }: EditClientModalProps) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm<FormCreateClient>({ resolver: yupResolver(createClientYuq) });

  useEffect(() => {
    if (open && client) {
      reset({
        clientName: client?.clientName || '',
        clientEmail: client?.clientEmail || '',
        contactPerson: client?.contactPerson || ''
      });
    }
    if (!open) {
      reset({
        clientName: '',
        clientEmail: '',
        contactPerson: ''
      });
    }
  }, [client, open, reset]);
  return (
    <DialogConfirm
      isOpen={open}
      onClose={onClose}
      textTitle="Edit Client"
      textButton="Save"
      onSubmit={handleSubmit(onSubmit)}>
      <Stack gap={2} width={'100%'}>
        <InputText
          title={'Client Name'}
          inputError={errors.clientName?.message}
          placeholder={'Client Name'}
          inputProps={{
            ...register('clientName')
          }}
        />
        <InputText
          title={'Client Email'}
          inputError={errors.clientEmail?.message}
          placeholder={'Client Email'}
          inputProps={{
            ...register('clientEmail')
          }}
        />
        <InputText
          inputError={errors.contactPerson?.message}
          title={'Contact Person'}
          placeholder={'Contact Person'}
          inputProps={{
            ...register('contactPerson')
          }}
        />
      </Stack>
    </DialogConfirm>
  );
};
